import CroustilleElement from "../lib/CroustilleElement";

const CROUSTILLE = window.CROUSTILLE || {};

class CityList extends CroustilleElement {
  constructor() {
    super("city-list");
  }

  mouseEnter() {
    CROUSTILLE.cityList.active = true;
    this.openCompanion();
    this.setAttribute("data-active", true);
  }

  mouseLeave() {
    CROUSTILLE.cityList.active = false;
  }

  select(e, s) {
    const companion = this.child("companion", document);
    this.selectors.forEach((o) =>
      o.dataset.slug === s.dataset.slug
        ? (o.dataset.active = "true")
        : (o.dataset.active = "")
    );
    companion
      .querySelectorAll("[data-slug]")
      .forEach((el) => (el.dataset.active = ""));
    const active = companion.querySelector(`[data-slug="${s.dataset.slug}"]`);
    active.dataset.active = "true";
    this.dataset.active = s.dataset.slug;

    if (!active) {
      return;
    }

    const offset = companion.scrollTop;
    const elementPosition =
      active.getBoundingClientRect().top -
      active.offsetParent.getBoundingClientRect().top;
    const offsetPosition =
      elementPosition + offset - this.selectors[0].getBoundingClientRect().top;

    companion.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  }

  openCompanion() {
    const companion = this.child("companion", document);

    if (
      CROUSTILLE.cityList.active === true &&
      companion.dataset.open !== "true"
    ) {
      console.log("open companion");
      companion && (companion.dataset.open = "true");
    }
  }

  maybeCloseCompanion() {
    if (CROUSTILLE.cityList.active === false) {
      console.log("close companion");
      const companion = this.child("companion", document);
      companion && (companion.dataset.open = "");
    }
  }

  init() {
    CROUSTILLE.cityList = {};
    this.companionEventAttached = false;
    this._mouseEnter = this.mouseEnter.bind(this);
    this._mouseLeave = this.mouseLeave.bind(this);

    this.selectors = this.children("selector");
    this.selectors.forEach((s) => {
      s.addEventListener("mouseover", (e) => this.select(e, s));
      s.addEventListener("mouseenter", this._mouseEnter);
      // s.addEventListener("mouseleave", this._mouseLeave);
    });

    // window.addEventListener("DOMContentLoaded", () => {
    //   if (!this.companionEventAttached) {
    //     const companion = this.child("companion", document);
    //     companion && companion.addEventListener("mouseenter", this._mouseEnter);
    //     companion && companion.addEventListener("mouseleave", this._mouseLeave);
    //     this.companionEventAttached = true;
    //   }
    // });

    this._maubeCloseCompanion = this.maybeCloseCompanion.bind(this);
    this.interval = setInterval(this._maubeCloseCompanion, 2000);

    window.addEventListener("click", (e) => {
      if (!this.contains(e.target)) {
        // clicked outside city-list
        this.removeAttribute("data-active");
        this.mouseLeave();
      }
    });
  }

  destroy() {
    this.removeEventListener("mouseenter", this._mouseEnter);
    // this.removeEventListener("mouseleave", this._mouseLeave);

    // const companion = this.child("companion", document);
    // companion && companion.removeEventListener("mouseenter", this._mouseEnter);
    // companion && companion.removeEventListener("mouseleave", this._mouseLeave);

    // this.interval && clearInterval(this.interval);
  }
}

export default CityList;
